<template>
    <modal
        name="login"
        :classes="['v--modal', 'login', 'error-modal']"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        :width="400"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">{{ $t("login.authorization") }}</div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <section class="login">
                <form @submit.prevent="login" autocomplete="on">
                    <div class="form-group">
                        <label for="username" class="label"
                            >{{ $t("login.phoneEmail") }}:</label
                        >
                        <input
                            type="text"
                            v-model="username"
                            name="username"
                            v-validate="'required'"
                            id="username"
                            autocomplete="username"
                            class="input"
                            :class="{ 'field-error': errors.has('username') }"
                        />

                        <!-- <label for="username" class="v-error label-tip">{{
                            errors.first("username")
                        }}</label> -->
                        <label for="username" class="v-error label-tip">{{
                            errorMessageLogin
                        }}</label>
                    </div>
                    <div class="form-group">
                        <label for="password" class="label"
                            >{{ $t("login.password") }}:</label
                        >
                        <input
                            type="password"
                            v-model="password"
                            v-validate="'required|min:6'"
                            id="password"
                            name="password"
                            autocomplete="current-password"
                            class="input"
                            :class="{ 'field-error': errors.has('password') }"
                        />

                        <!-- <label for="password" class="v-error label-tip">
                            {{ errors.first("password") }}
                        </label> -->

                        <label for="password" class="v-error label-tip">
                            {{ errorMessagePassword }}
                        </label>
                    </div>
                    <div class="checkbox-group">
                        <input
                            v-model="notRemember"
                            type="checkbox"
                            id="not-remember"
                            class="input-checkbox"
                        />
                        <label for="not-remember" class="checkbox-label">{{
                            $t("login.someoneComputer")
                        }}</label>
                    </div>
                    <div class="form-bottom buttons-center">
                        <button v-if="!loader" type="submit" class="button">
                            {{ $t("login.logIn") }}
                        </button>
                        <button v-if="loader" class="button-loader"></button>
                        <Social />
                        <span
                            @click="
                                $modal.hide('login');
                                $modal.show('reset-password');
                            "
                            class="link reset-password"
                            >{{ $t("login.restoreAccess") }}</span
                        >
                    </div>
                </form>
            </section>
        </div>
    </modal>
</template>

<script>
import redirectButton from "@/components/Buttons/Redirect";
import Social from "@/components/Blocks/Social";
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { initAfterLogin } from "@/mixins/initAfterLogin";
import { checkScroll } from "@/mixins/checkScroll";
import Vue from "vue";

export default {
    name: "Login",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        Social,
    },
    mixins: [localizeValidation, initAfterLogin, checkScroll],
    data() {
        return {
            email: "",
            username: "",
            password: "",
            loader: false,
            notRemember: false,
            nonFieldErrors: [],
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userErrors: "user/errors",
            isEmpty: "user/isEmpty",
        }),
        errorMessagePassword() {
            if (this.errors.first("password")) {
                if (
                    this.errors.first("password") ===
                    this.$t("login.atLeastCharacters")
                ) {
                    return this.$t("login.atLeastCharacters");
                } else {
                    return this.$t("login.required");
                }
            } else {
                return "";
            }
        },
        errorMessageLogin() {
            if (this.errors.first("username")) {
                if (
                    this.errors.first("username") === this.$t("login.required")
                ) {
                    return this.$t("login.required");
                }
            } else {
                return "";
            }
        },
    },
    created() {
        this.localizeValidation();
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        close() {
            this.$modal.hide("login");
        },
        isNumeric(value) {
            return /^\d+$/.test(value);
        },
        formatPhoneNumber(phoneNumber) {
            // Удаляем все нецифровые символы из номера телефона и обрезаем до 11 символов
            let cleaned = ("" + phoneNumber)
                .replace(/\D/g, "")
                .substring(0, 11);
            // Если номер телефона начинается с "8", заменяем на "+7"
            if (cleaned.startsWith("8")) {
                cleaned = "7" + cleaned.slice(1);
            }
            // Добавляем формат
            let formatted = cleaned.replace(
                /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
                "+$1$2$3$4$5"
            );
            return formatted;
        },
        login() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    // Удаляем пробелы в конце строки перед форматированием номера телефона
                    let trimmedUsername = this.username.trim();
                    // Проверяем, если строка содержит ".ru" или ".com", то она скорее всего почта, а не номер телефона
                    let isEmail =
                        trimmedUsername.includes(".ru") ||
                        trimmedUsername.includes(".com");
                    // Форматируем номер телефона только если введены цифры и это не почта
                    let formattedUsername =
                        !isEmail && this.isNumeric(trimmedUsername)
                            ? this.formatPhoneNumber(trimmedUsername)
                            : trimmedUsername;

                    this.loader = true;

                    this.$store
                        .dispatch("user/login", {
                            username: formattedUsername,
                            password: this.password,
                            not_remember: this.notRemember,
                        })
                        .then(() => {
                            if (!this.isEmpty("errors")) {
                                throw new Error("Some errors");
                            }
                            this.initAfterLogin();
                            this.username = "";
                            this.password = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.notRemember = false;
                            if (
                                !this.isEmpty("user") &&
                                (!this.user.first_name ||
                                    !this.user.last_name ||
                                    (this.user.gender != 1 &&
                                        this.user.gender != 2) ||
                                    !this.user.birthday)
                            ) {
                                this.$modal.show("first-login");
                            }
                            this.$router.push({ name: "home" });
                            this.loader = false;
                            const vm = new Vue();
                            vm.$connect();
                            this.close();
                        })
                        .catch(() => {
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0],
                                });
                            }
                            if (this.userErrors.disabled_user) {
                                if (this.userErrors.disabled_user[0] == 0) {
                                    this.$modal.show("dialog", {
                                        title: this.$t("login.error"),
                                        text: this.$t(
                                            "login.yourAccountActivatedYet"
                                        ),
                                        buttons: [
                                            { title: this.$t("albumEdit.ok") },
                                        ],
                                    });
                                } else if (
                                    this.userErrors.disabled_user[0] == 1
                                ) {
                                    this.close();
                                    this.$modal.show("confirm-phone", {
                                        register: true,
                                        phone: this.username,
                                        password: this.password,
                                    });
                                }
                            }
                            this.loader = false;
                        });
                }
            });
        },
        // login() {
        //     this.$validator.validateAll().then((valid) => {
        //         if (valid) {
        //             this.loader = true;

        //             this.$store
        //                 .dispatch("user/login", {
        //                     username: this.username,
        //                     password: this.password,
        //                     not_remember: this.notRemember,
        //                 })
        //                 .then(() => {
        //                     if (!this.isEmpty("errors")) {
        //                         throw new Error("Some errors");
        //                     }
        //                     this.initAfterLogin();
        //                     this.username = "";
        //                     this.password = "";
        //                     this.errors.clear();
        //                     this.$validator.reset();
        //                     this.notRemember = false;
        //                     if (
        //                         !this.isEmpty("user") &&
        //                         (!this.user.first_name ||
        //                             !this.user.last_name ||
        //                             (this.user.gender != 1 &&
        //                                 this.user.gender != 2) ||
        //                             !this.user.birthday)
        //                     ) {
        //                         this.$modal.show("first-login");
        //                     }
        //                     this.$router.push({ name: "home" });
        //                     this.loader = false;
        //                     const vm = new Vue();
        //                     vm.$connect();
        //                     this.close();
        //                 })
        //                 .catch(() => {
        //                     for (let key in this.userErrors) {
        //                         this.errors.add({
        //                             field: key,
        //                             msg: this.userErrors[key][0],
        //                         });
        //                     }
        //                     if (this.userErrors.disabled_user) {
        //                         if (this.userErrors.disabled_user[0] == 0) {
        //                             this.$modal.show("dialog", {
        //                                 title: this.$t("login.error"),
        //                                 text: this.$t(
        //                                     "login.yourAccountActivatedYet"
        //                                 ),
        //                                 buttons: [
        //                                     { title: this.$t("albumEdit.ok") },
        //                                 ],
        //                             });
        //                         } else if (
        //                             this.userErrors.disabled_user[0] == 1
        //                         ) {
        //                             this.close();
        //                             this.$modal.show("confirm-phone", {
        //                                 register: true,
        //                                 phone: this.username,
        //                                 password: this.password,
        //                             });
        //                         }
        //                     }
        //                     this.loader = false;
        //                 });
        //         }
        //     });
        // },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_login";
</style>
